<template>
  <div class="dl" v-if="item">
    <div class="pay">
      <span class="title">购买文档:</span>
      <div class="introduction_center">
        <div class="introduction_center_left">
          <el-image :src="img"></el-image>
          <div class="comi">
            <span>文件名称:{{ item.name }}.{{ item.type }}</span><br />
            <span>文档大小:{{ item.fileSize}}</span>
            <span>需要知识币:{{ item.money}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="payment">
      <V-payment :item="item" :userInfo="userInfo"></V-payment>
    </div>
  </div>
</template>

<script>
import payment from "@/components/payment/index.vue";
import { getResourceById} from "@/services";
import api from '@/services/config.js'
export default {
  components: {
    "V-payment": payment,
  },
  data() {
    return {
      item:null,
      userInfo:null,

      img: require("@/assets/img/WORD.png"),
      name: "利用python进行数据分析",
      Febulous: "168kb",
      id: 190,
      Price: "",
      classification: "",
      download: 0,
      showWho: false // 
    };
  },
  created() {
    let ui = sessionStorage.getItem('userInfo');
    console.log(ui, 123);
    try {
      if (ui) {
        this.userInfo = JSON.parse(ui);
      }
    } catch (error) {

    }

    this.getZyInfo();
  },
  methods: {
    getZyInfo(){
      let id = this.$route.query.id;
      let data = {resourceId:id||0};
      getResourceById(data).then(res=>{
        if(res.success){
          this.item = res.data;
          let type = this.item?.type||"";
          if (type == "mp3") {
            this.img = require("@/assets/img/MP3.png");
          } else if (type == "mp4") {
            this.img = require("@/assets/img/MP4.png");
          } else if (type == "jpg" || type == "jpeg") {
            this.img = api.concat(this.item.coverImg);
          } else if (type == "png") {
            this.img = api.concat(this.item.coverImg);
          } else if(type == 'docx'){
            this.url = require("@/assets/icon/WORD@2x.png");
          }else if(type == 'txt'){
            this.url = require("@/assets/icon/txt(1)@2x.png");
          }else if(type == 'pdf'){
            this.url = require("@/assets/icon/PDF48@2x.png");
          }else if(type == 'ppt'){
            this.url = require("@/assets/icon/ppt@2x.png")
          }else{
            this.url = require("@/assets/icon/？@2x.png");
          }
        }else{
          this.$message({
            message:res.message,
            type:'warning'
          })
        }
      })

    }

  },
};
</script>
<style scoped>
.dl {
  background-color: #ffffff;
  margin: 0 161px 30px 139px;
  padding: 10px 20px 57px 0px;
}

.el-breadcrumb {
  margin: 30px 0px 0px 30px;
}

.pay {
  border: 1px solid #f7f7f7;
  margin: 10px;
  padding: 20px;
  margin-top: 65px;
}

.payment {
  border: 1px solid #f7f7f7;
  margin: 10px;
  padding: 80px 50px 50px 50px;
  margin-top: 41px;
  background-color: #f7f7f7;
}

.pay .title {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
  line-height: 24px;
  float: left;
}

.introduction_center {
  overflow: hidden;
  background-color: #f7f7f7;
  width: 68%;
  margin-left: 8%;
}

.introduction_center_left {
  float: left;
  margin-left: 30px;
}

.introduction_center_left .el-image {
  width: 23px;
  float: left;
  margin-top: 13px;
}

.introduction_center_left span {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 300;
  color: rgba(0, 0, 0, 1);
  line-height: 24px;
  margin-left: 10px;
}

.comi {
  float: left;
  padding: 10px;
}
</style>
